import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Card, CardActionArea, CardContent, CardMedia, Typography } from '@mui/material';

import { Icon } from 'app/main/components';
import { showTotemDocumentsFoldersDialog } from '../dialogs/TotemDocumentsFoldersDialog';

interface TotemDocumentsFolderItemProps {
	model: any;
}

const FadeOverlay = () => (
	<Box
		className="align-middle absolute bottom-0 left-0 h-64 w-full text-center"
		sx={theme => ({
			backgroundImage: `linear-gradient(to top, ${theme.palette.background.paper}, 75%, transparent)`
		})}
	/>
);

export default function TotemDocumentsFolderItem(props: TotemDocumentsFolderItemProps) {
	const dispatch = useDispatch();

	const thumbnailUrl = props.model.fold_image
		? `${import.meta.env.VITE_ENDPOINT}/resources/documents-folders/thumbnails/${props.model.fold_image}?v=${Date.now()}`
		: undefined;

	const handleOpen = () => {
		dispatch(
			showTotemDocumentsFoldersDialog({ folderUid: props.model.fold_uid, folderTitle: props.model.fold_title })
		);
	};

	return (
		<Card className="relative h-full rounded-lg" variant="outlined">
			<CardActionArea className="flex h-full flex-col justify-start" onClick={handleOpen}>
				<CardMedia className="flex h-160 w-full items-center justify-center" image={thumbnailUrl}>
					{!props.model.fold_image ? <Icon icon="folder-outline" size={96} /> : <></>}
				</CardMedia>
				<CardContent className="flex flex-col items-center justify-center text-center">
					<Typography gutterBottom variant="subtitle2">
						{props.model.fold_title}
					</Typography>
					<Typography
						variant="body2"
						color="text.secondary"
						sx={{ minHeight: '10vh', maxHeight: '10vh', overflow: 'hidden' }}
					>
						{props.model.fold_description}
					</Typography>
					<FadeOverlay />
				</CardContent>
			</CardActionArea>
		</Card>
	);
}
